import {
	LayoutDashboard,
	Activity,
	TestTube,
	BarChart3,
	Users,
	UserCog,
	Briefcase,
	Store,
	Zap,
	Globe,
	Package,
	Battery,
	Building2,
} from "lucide-react";
import { createSideNavIcon } from "components/layout-components/SideNavIcon";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoCarregadorEnum,
	PermissaoCentroDistribuicaoEnum,
	PermissaoClienteEnum,
	PermissaoGrupoUsuarioEnum,
	PermissaoModeloBateriaEnum,
	PermissaoTipoBateriaEnum,
	PermissaoTesteBateriaEnum,
	PermissaoUsuarioEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "dashboard",
		path: `${APP_PREFIX_PATH}/dashboard`,
		title: "dashboard",
		icon: createSideNavIcon(LayoutDashboard),
		breadcrumb: false,
		submenu: [],
	},
	{
		key: "dashboard-teste-bateria",
		path: `${APP_PREFIX_PATH}/dashboard-teste-bateria`,
		title: "dashboard-teste-bateria",
		icon: createSideNavIcon(Activity),
		breadcrumb: false,
		submenu: [],
		permissao: [PermissaoTesteBateriaEnum.REALIZAR_TESTE_BATERIA],
	},
	{
		key: "logs",
		path: `${APP_PREFIX_PATH}/logs`,
		title: "logs",
		icon: createSideNavIcon(TestTube),
		breadcrumb: false,
		submenu: [],
		permissao: [PermissaoTesteBateriaEnum.REALIZAR_TESTE_BATERIA],
	},
	{
		key: "relatorios",
		path: `${APP_PREFIX_PATH}/relatorios`,
		title: "relatorios",
		icon: createSideNavIcon(BarChart3),
		breadcrumb: false,
		submenu: [],
		permissao: [PermissaoTesteBateriaEnum.REALIZAR_TESTE_BATERIA],
	},
	{
		key: "lista-usuarios",
		path: `${APP_PREFIX_PATH}/lista-usuarios`,
		title: "lista-usuarios",
		icon: createSideNavIcon(Users),
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoUsuarioEnum.GERENCIAR_USUARIO_PARA_QUALQUER_CLIENTE,
			PermissaoUsuarioEnum.GERENCIAR_USUARIO_PARA_QUALQUER_CENTRO_DISTRIBUICAO,
			PermissaoUsuarioEnum.GERENCIAR_USUARIO_APENAS_PROPRIO_CENTRO_DISTRIBUICAO,
		],
	},
	{
		key: "lista-grupos-usuario",
		path: `${APP_PREFIX_PATH}/lista-grupos-usuario`,
		title: "lista-grupos-usuario",
		icon: createSideNavIcon(UserCog),
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoGrupoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "lista-clientes",
		path: `${APP_PREFIX_PATH}/lista-clientes`,
		title: "lista-clientes",
		icon: createSideNavIcon(Briefcase),
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoClienteEnum.VISUALIZAR,
	},
	{
		key: "lista-centros-distribuicao",
		path: `${APP_PREFIX_PATH}/lista-centros-distribuicao`,
		title: "lista-centros-distribuicao",
		icon: createSideNavIcon(Store),
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoCentroDistribuicaoEnum.GERENCIAR_CENTRO_DISTRIBUICAO_PARA_QUALQUER_CLIENTE,
			PermissaoCentroDistribuicaoEnum.GERENCIAR_CENTRO_DISTRIBUICAO_APENAS_PROPRIO_CLIENTE,
		],
	},
	{
		key: "lista-carregadores",
		path: `${APP_PREFIX_PATH}/lista-carregadores`,
		title: "lista-carregadores",
		icon: createSideNavIcon(Zap),
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoCarregadorEnum.GERENCIAR_CARREGADOR_PARA_QUALQUER_CLIENTE,
			PermissaoCarregadorEnum.GERENCIAR_CARREGADOR_APENAS_PROPRIO_CLIENTE,
			PermissaoCarregadorEnum.VISUALIZAR_PROPRIO_CENTRO,
		],
	},
	{
		key: "lista-carregadores-admin",
		path: `${APP_PREFIX_PATH}/lista-carregadores-admin`,
		title: "lista-carregadores-admin",
		icon: createSideNavIcon(Globe),
		breadcrumb: false,
		submenu: [],
		permissao: [PermissaoCarregadorEnum.GERENCIAR_CARREGADOR_ADMIN_PUBLIC],
	},
	{
		key: "lista-middleware-releases",
		path: `${APP_PREFIX_PATH}/lista-middleware-releases`,
		title: "lista-middleware-releases",
		icon: createSideNavIcon(Package),
		breadcrumb: false,
		submenu: [],
		permissao: [PermissaoCarregadorEnum.GERENCIAR_CARREGADOR_ADMIN_PUBLIC],
	},
	{
		key: "lista-tipos-bateria",
		path: `${APP_PREFIX_PATH}/lista-tipos-bateria`,
		title: "lista-tipos-bateria",
		icon: createSideNavIcon(Battery),
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoTipoBateriaEnum.VISUALIZAR,
			PermissaoTipoBateriaEnum.GERENCIAR,
		],
	},
	{
		key: "lista-modelos-bateria",
		path: `${APP_PREFIX_PATH}/lista-modelos-bateria`,
		title: "lista-modelos-bateria",
		icon: createSideNavIcon(Building2),
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoModeloBateriaEnum.VISUALIZAR,
			PermissaoModeloBateriaEnum.EXCLUIR,
			PermissaoModeloBateriaEnum.GERENCIAR_MODELO_BATERIA_PARA_QUALQUER_CLIENTE,
			PermissaoModeloBateriaEnum.GERENCIAR_MODELO_BATERIA_APENAS_PROPRIO_CLIENTE,
		],
	},
	{
		key: "lista-modelo-bateria-serie-override",
		path: `${APP_PREFIX_PATH}/lista-modelo-bateria-serie-override`,
		title: "lista-modelo-bateria-serie-override",
		icon: createSideNavIcon(Building2),
		breadcrumb: false,
		submenu: [],
		permissao: [
			PermissaoModeloBateriaEnum.VISUALIZAR,
			PermissaoModeloBateriaEnum.GERENCIAR_MODELO_BATERIA_PARA_QUALQUER_CLIENTE,
			PermissaoModeloBateriaEnum.GERENCIAR_MODELO_BATERIA_APENAS_PROPRIO_CLIENTE,
		],
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
